/* =============================================================================
 * YOUSHARES · Amazon 引流跳转配置与解析层
 * -----------------------------------------------------------------------------
 * 一处配置，多产品 × 多国。页面按钮只需 data-amz="产品slug"，不需要写死链接。
 *
 * 【当前上线范围】仅美国站(US)。其余国家已预留配置位，enabled:false，
 *   将来开站时把对应国家 enabled 改 true、并在 LINKS 里填入该国归因链接即可，
 *   页面 HTML 一行都不用改。
 *
 * 【解析规则】
 *   1. 探测访客所在国家(见 detectCountry)，落到某个 MARKET。
 *   2. 若该 MARKET 未启用或无此产品链接 → 回退到 FALLBACK_MARKET(默认 US)。
 *   3. 仍取不到 → 保留按钮占位(不跳转)并在 console 告警，绝不乱跳。
 * ========================================================================== */
(function (global) {
  'use strict';

  /* 回退市场：任何国家取不到链接时，统一回退到这里 */
  var FALLBACK_MARKET = 'US';

  /* 是否强制只用回退市场(上线初期只做美国时设 true，可跳过地理探测) */
  var SINGLE_MARKET_MODE = true;

  /* ---------------------------------------------------------------------------
   * 1) 市场表 MARKETS
   *    key = ISO 国家码；domain 仅作参考/兜底裸链接用；enabled 控制是否启用。
   *    只有 enabled:true 的市场才会被地理分流命中；其余为预留位。
   *    开新国家：把该行 enabled 改 true，并在 LINKS 里补该国链接。
   * ------------------------------------------------------------------------- */
  var MARKETS = {
    US: { name: '美国',       domain: 'www.amazon.com',    enabled: true  },
    CA: { name: '加拿大',     domain: 'www.amazon.ca',     enabled: false },
    UK: { name: '英国',       domain: 'www.amazon.co.uk',  enabled: false },
    DE: { name: '德国',       domain: 'www.amazon.de',     enabled: false },
    FR: { name: '法国',       domain: 'www.amazon.fr',     enabled: false },
    IT: { name: '意大利',     domain: 'www.amazon.it',     enabled: false },
    ES: { name: '西班牙',     domain: 'www.amazon.es',     enabled: false },
    NL: { name: '荷兰',       domain: 'www.amazon.nl',     enabled: false },
    SE: { name: '瑞典',       domain: 'www.amazon.se',     enabled: false },
    PL: { name: '波兰',       domain: 'www.amazon.pl',     enabled: false },
    JP: { name: '日本',       domain: 'www.amazon.co.jp',  enabled: false },
    AU: { name: '澳大利亚',   domain: 'www.amazon.com.au', enabled: false },
    AE: { name: '阿联酋',     domain: 'www.amazon.ae',     enabled: false },
    SA: { name: '沙特',       domain: 'www.amazon.sa',     enabled: false },
    MX: { name: '墨西哥',     domain: 'www.amazon.com.mx', enabled: false },
    SG: { name: '新加坡',     domain: 'www.amazon.sg',     enabled: false }
  };

  /* ---------------------------------------------------------------------------
   * 2) 产品表 PRODUCTS
   *    key = 产品 slug(页面按钮 data-amz 里用的就是它)。
   *    label 仅用于告警/对照，方便识别；新增产品在此加一行 + 在 LINKS 补链接。
   * ------------------------------------------------------------------------- */
  var PRODUCTS = {
    'h2-insulin':  { label: 'H2 温显胰岛素包（Insulin Cooler w/ Temp Display）' },
    'y7-eva':      { label: 'Y7 EVA胰岛素包（Portable EVA Insulin Case）' },
    'y13-vial':    { label: 'Y13 胰岛素瓶收纳袋（Insulin Vial Pouch）' },
    'c2-glp1-cup': { label: 'C2 温显GLP1杯（GLP-1 Cooler w/ Temp Display）' },
    'c3-electric': { label: 'C3 电动制冷杯（Electric Insulin Cooler Z100）' },
    'd1-mini':     { label: 'D1 迷你电动制冷杯（Mini Electric Cooler）' },
    'v5-glp1-bag': { label: 'V5 GLP1收纳包（GLP-1 / Zepbound Travel Case）' },
    'g3-vial-box': { label: 'G3 胰岛素瓶冰盒包（Vial Ice-Brick Organizer）' },
    'g4-8hole':    { label: 'G4 8孔瓶收纳包（8-Slot Vial Organizer）' },
    'c3-03':       { label: 'C3-03 电动制冷杯 Z100' },
    'c3-3a':       { label: 'C3-3A 电动制冷杯 Z100' },
    'c3-set':      { label: 'C3 套装 制冷杯+移动电源 Z100' },
    'c3-magnolia': { label: 'C3 玉兰花 电动制冷杯 Z100（无归因）' },
    'c3-glitter':  { label: 'C3 闪粉 电动制冷杯 Z100（无归因）' },
    'brand-store': { label: 'Brand Store（Amazon 品牌旗舰店，品牌级 CTA）' },
    'g3-blue':     { label: 'G3 EVA-PU 蓝色（Vial Ice-Box）' },
    'g3-green':    { label: 'G3 EVA-PU 绿色（Vial Ice-Box）' },
    'g3-black':    { label: 'G3 EVA-PU 黑色（Vial Ice-Box）' },
    'g3-camellia': { label: 'G3 蓝底油茶花（Vial Ice-Box）' },
    'g4-green':    { label: 'G4 8孔 绿色（Vial Organizer）' }
  };

  /* 页面级默认产品：通用 CTA(data-amz 不带 slug 或带 "default")落到这款。
     取最畅销主推款 H2。 */
  var DEFAULT_PRODUCT = 'h2-insulin';

  /* ---------------------------------------------------------------------------
   * 3) 链接表 LINKS  ——  [产品 slug][国家码] = "Amazon Attribution 链接"
   *    ★ 美国先填(现在留空占位，拿到链接后粘进 US: "…" 即可)。
   *    ★ 其余国家已建好空位；开站时把对应国家的空串换成真实链接。
   *    留空("")表示尚未配置：解析时会回退美国，仍无则保留占位并告警。
   * ------------------------------------------------------------------------- */
  var EMPTY_ROW = function () {
    return { US:'', CA:'', UK:'', DE:'', FR:'', IT:'', ES:'', NL:'',
             SE:'', PL:'', JP:'', AU:'', AE:'', SA:'', MX:'', SG:'' };
  };
  var LINKS = {
    'h2-insulin':  EMPTY_ROW(), 'y7-eva':      EMPTY_ROW(), 'y13-vial':    EMPTY_ROW(),
    'c2-glp1-cup': EMPTY_ROW(), 'c3-electric': EMPTY_ROW(), 'd1-mini':     EMPTY_ROW(),
    'v5-glp1-bag': EMPTY_ROW(), 'g3-vial-box': EMPTY_ROW(), 'g4-8hole':    EMPTY_ROW(),
    'c3-03':       EMPTY_ROW(), 'c3-3a':       EMPTY_ROW(), 'c3-set':      EMPTY_ROW(),
    'c3-magnolia': EMPTY_ROW(), 'c3-glitter':  EMPTY_ROW(),
    'brand-store': EMPTY_ROW(),
    'g3-blue':     EMPTY_ROW(), 'g3-green':    EMPTY_ROW(), 'g3-black':    EMPTY_ROW(),
    'g3-camellia': EMPTY_ROW(), 'g4-green':    EMPTY_ROW()
  };

/* 2026-07-21 美国站 Attribution 链接（8/9 已配；campaign 对应：
     US-H2 / US-Y7 / US-Y13 / US-C3老款 / US-D1 / US-V5 / US-G3 / US-G3&G4）。
     c2-glp1-cup 的 campaign 未创建（新品等通知），暂走裸链接兜底。
     ⚠ 点击按钮后次日在 Attribution 后台核对对应广告组出现点击，验证链接无误。 */
  LINKS['h2-insulin'].US  = 'https://www.amazon.com/dp/B0D2W58WMD?maas=maas_adg_B6F3E465DC9E239754CBE743ACEC4CAB_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['y7-eva'].US      = 'https://www.amazon.com/dp/B0F4XQ6NXQ?maas=maas_adg_AD6EEE8D15988A8D74AB0448B472CB39_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['y13-vial'].US    = 'https://www.amazon.com/dp/B0FBWSYQH8?maas=maas_adg_F8C1DF0E850937A6DFD6BBC45DA9A188_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['c3-electric'].US = 'https://www.amazon.com/dp/B0F6TK4PGT?maas=maas_adg_C84C309EBDB09510742138D3FC544EE2_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['d1-mini'].US     = 'https://www.amazon.com/dp/B0H32NPJ1T?maas=maas_adg_6BCA2EDC3DFBABBDAEF01E1B2C33D961_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['v5-glp1-bag'].US = 'https://www.amazon.com/dp/B0H1QJW685?maas=maas_adg_B60FA1DBABE8A6CEE0BB1F34E03628BA_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['g3-vial-box'].US = 'https://www.amazon.com/dp/B0F6VH6DHD?maas=maas_adg_964185F04EFD69101EA2C0271992D00A_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['g4-8hole'].US    = 'https://www.amazon.com/dp/B0G3WBKT2C?maas=maas_adg_8B40AE5760DB1023B262D3B107F62B3C_afap_abs&ref_=aa_maas&tag=maas';
  /* C3 各独立 SKU：03/3A/套装 有归因；玉兰花/闪粉 无归因(走 ASINS 裸链) */
  LINKS['c3-03'].US       = 'https://www.amazon.com/dp/B0GZZQF3QS?maas=maas_adg_E2151A59F717BDCE582F2E4A2EC60515_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['c3-3a'].US       = 'https://www.amazon.com/dp/B0GCYNY45R?maas=maas_adg_0C224C446D9F5B57979DCB8A6C2BEEE1_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['c3-set'].US      = 'https://www.amazon.com/dp/B0FJXR94P4?maas=maas_adg_C154A2556314EBD2076516097656F074_afap_abs&ref_=aa_maas&tag=maas';
  /* 品牌 Store 归因链接（品牌级 CTA：顶部导航 SHOP NOW、finalcta、GLP-1 促销条等） */
  LINKS['brand-store'].US = 'https://www.amazon.com/stores/page/246B90A6-D60F-442A-8CCF-CEF4162DD280?maas=maas_adg_740AD29F82FE36DEB64E76B27F982A0E_afap_abs&ref_=aa_maas&tag=maas';
  /* G3/G4 变体归因：用户 US-G3&G4 campaign(maas_adg_8B40AE)，各变体用自身 ASIN + 同一追踪码 */
  LINKS['g3-blue'].US     = 'https://www.amazon.com/dp/B0FXG9XRQF?maas=maas_adg_8B40AE5760DB1023B262D3B107F62B3C_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['g3-green'].US    = 'https://www.amazon.com/dp/B0FXGBLDCR?maas=maas_adg_8B40AE5760DB1023B262D3B107F62B3C_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['g3-black'].US    = 'https://www.amazon.com/dp/B0FXG7N4SX?maas=maas_adg_8B40AE5760DB1023B262D3B107F62B3C_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['g3-camellia'].US = 'https://www.amazon.com/dp/B0FGCX4992?maas=maas_adg_8B40AE5760DB1023B262D3B107F62B3C_afap_abs&ref_=aa_maas&tag=maas';
  LINKS['g4-green'].US    = 'https://www.amazon.com/dp/B0G3W9JYL4?maas=maas_adg_8B40AE5760DB1023B262D3B107F62B3C_afap_abs&ref_=aa_maas&tag=maas';


  /* 裸链接兜底：无 Attribution 链接时，用 https://<域名>/dp/<ASIN> 直接跳。
     US ASIN 来源:9款型号产品清单(组内销量最高变体)。其余国家留空=回退US。
     ★ 现在可立即用于搭站/联调；投广告前请在 LINKS 填 Attribution 链接覆盖它。 */
  var ASINS = {
    'h2-insulin':  { US:'B0D2W58WMD' }, 'y7-eva':      { US:'B0B429Z5K2' },
    'y13-vial':    { US:'B0FBWSYQH8' }, 'c2-glp1-cup': { US:'B0H5PK3RS1' },
    'c3-electric': { US:'B0F6TK4PGT' }, 'd1-mini':     { US:'B0H32NPJ1T' },
    'v5-glp1-bag': { US:'B0H1QJW685' }, 'g3-vial-box': { US:'B0F6VH6DHD' },
    'g4-8hole':    { US:'B0G3WBKT2C' },
    'c3-03':       { US:'B0GZZQF3QS' }, 'c3-3a':       { US:'B0GCYNY45R' },
    'c3-set':      { US:'B0FJXR94P4' }, 'c3-magnolia': { US:'B0F6TLTC4H' },
    'c3-glitter':  { US:'B0F6T613BP' },
    'g3-blue':     { US:'B0FXG9XRQF' }, 'g3-green':    { US:'B0FXGBLDCR' },
    'g3-black':    { US:'B0FXG7N4SX' }, 'g3-camellia': { US:'B0FGCX4992' },
    'g4-green':    { US:'B0G3W9JYL4' }
  };

  /* ---------------------------------------------------------------------------
   * 4) 地理探测 detectCountry()
   *    返回一个国家码。优先级：
   *      a. URL 上 ?market=XX 手动覆盖(便于逐国测试)
   *      b. SINGLE_MARKET_MODE=true 时直接用回退市场(上线初期只做美国)
   *      c. window.YS_COUNTRY(由 Shopify/边缘节点注入的真实国家码)
   *      d. 都没有 → 回退市场
   *    注：浏览器端拿不到可靠 IP 国家，真正的地理分流应在 /go 边缘层(见对照表文档)。
   * ------------------------------------------------------------------------- */
  function detectCountry() {
    try {
      var q = new URLSearchParams(global.location.search).get('market');
      if (q && MARKETS[q.toUpperCase()]) return q.toUpperCase();
    } catch (e) {}
    if (SINGLE_MARKET_MODE) return FALLBACK_MARKET;
    if (global.YS_COUNTRY && MARKETS[String(global.YS_COUNTRY).toUpperCase()]) {
      return String(global.YS_COUNTRY).toUpperCase();
    }
    return FALLBACK_MARKET;
  }

  /* ---------------------------------------------------------------------------
   * 5) 链接解析 resolve(productSlug, [country])
   *    返回 { url, market, product } ；url 为空串表示未配置(保留占位)。
   * ------------------------------------------------------------------------- */
  function resolve(productSlug, country) {
    var slug = (productSlug && PRODUCTS[productSlug]) ? productSlug : DEFAULT_PRODUCT;
    var mkt = country || detectCountry();

    // 若命中市场未启用，直接退回退市场
    if (!MARKETS[mkt] || !MARKETS[mkt].enabled) mkt = FALLBACK_MARKET;

    // 1) 归因链接优先
    var table = LINKS[slug] || {};
    var url = table[mkt] || '';
    if (!url && mkt !== FALLBACK_MARKET) { url = table[FALLBACK_MARKET] || ''; if (url) mkt = FALLBACK_MARKET; }
    if (url) return { url: url, market: mkt, product: slug, kind: 'attribution' };

    // 2) 裸链接兜底(无归因链接时，站点仍可用；投广告前须换归因链接)
    var arow = ASINS[slug] || {};
    var asin = arow[mkt] || '';
    if (!asin && mkt !== FALLBACK_MARKET) { asin = arow[FALLBACK_MARKET] || ''; if (asin) mkt = FALLBACK_MARKET; }
    if (asin && MARKETS[mkt]) {
      return { url: 'https://' + MARKETS[mkt].domain + '/dp/' + asin, market: mkt, product: slug, kind: 'bare' };
    }
    return { url: '', market: mkt, product: slug, kind: 'none' };
  }

  /* ---------------------------------------------------------------------------
   * 6) 绑定按钮 bind([root])
   *    给所有 [data-amz] 元素套上真实链接；data-amz 的值就是产品 slug。
   *    未配置的按钮保留原样(不跳转)并在 console 汇总告警，方便上线前排查。
   * ------------------------------------------------------------------------- */
  function bind(root) {
    root = root || global.document;
    if (!root || !root.querySelectorAll) return;
    var missing = [], bare = [];
    root.querySelectorAll('[data-amz]').forEach(function (a) {
      var slug = a.getAttribute('data-amz') || '';
      var r = resolve(slug);
      if (r.url) {
        a.setAttribute('href', r.url);
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener sponsored');
        a.setAttribute('data-amz-market', r.market);
        a.setAttribute('data-amz-kind', r.kind);
        if (r.kind === 'bare') bare.push(r.product);
      } else {
        missing.push(r.product + ' / ' + detectCountry());
      }
    });
    if (bare.length) {
      console.warn('[YOUSHARES] 以下产品当前走「裸链接」(无归因、无 BRB 返佣)，仅供搭站/联调：\n  ' +
        bare.join(', ') + '\n投放广告前请在 ys-amazon-links.js 的 LINKS 中填入 Amazon Attribution 链接。');
    }
    if (missing.length) {
      console.warn('[YOUSHARES] 以下「产品/市场」既无归因链接也无 ASIN，按钮未跳转：\n  ' +
        missing.join('\n  ') + '\n请在 ys-amazon-links.js 补齐。');
    }
  }

  /* 对外暴露：便于调试与 Shopify 主题里手动调用 */
  var API = {
    markets: MARKETS, products: PRODUCTS, links: LINKS, asins: ASINS,
    detectCountry: detectCountry, resolve: resolve, bind: bind,
    fallback: FALLBACK_MARKET
  };
  global.YS_AMZ = API;

  /* DOM 就绪后自动绑定一次 */
  if (global.document) {
    if (global.document.readyState !== 'loading') bind();
    else global.document.addEventListener('DOMContentLoaded', function () { bind(); });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = API;

})(typeof window !== 'undefined' ? window : this);
